import HorizontalCard from "Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCard";
import { HorizontalCardAddItem } from "Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCardAddItem/HorizontalCardAddItem";
import HorizontalCardAttachment from "Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCardAttachment/HorizontalCardAttachment";
import HorizontalCardImage from "Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCardImage/HorizontalCardImage";
import HorizontalCardGrid from "Components/Common/HorizontalCardGrid/HorizontalCardGrid";
import ContentView from "Components/ContentView/ContentView";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import { TaskTemplateStep } from "Models/Tasks/TaskTemplateStep";
import * as React from "react";
import Dotdotdot from "react-clamp";
import i18n from "Translations/i18n";
import { TaskTemplateStepsPopover } from "./TaskTemplateStepsPopover/TaskTemplateStepsPopover";

interface IProps {
    taskTemplate: TaskTemplate;
    onChange: (steps: TaskTemplateStep[], descriptionFile?: File) => void;
}

interface IState {
    steps: TaskTemplateStep[];
    descriptionFileUrl?: string;
    showStepsPopover: boolean;
    popoverPaneIndex: number;
}

export class TaskTemplateSteps extends React.Component<IProps, IState> {
    // Set it to 9999 to prevent a bug when duplicating a task, removing a step and then adding one
    private newStepId: number = 9999;

    constructor(props: IProps) {
        super(props);

        this.state = {
            steps: props.taskTemplate.steps,
            descriptionFileUrl: props.taskTemplate.descriptionFileUrl,
            showStepsPopover: false,
            popoverPaneIndex: 0
        };

        this.openPopover = this.openPopover.bind(this);
        this.closePopover = this.closePopover.bind(this);
        this.addInstruction = this.addInstruction.bind(this);
        this.descriptionFileUpdated = this.descriptionFileUpdated.bind(this);
        this.updateSteps = this.updateSteps.bind(this);
    }

    public openPopover(i: number) {
        return (e: { stopPropagation: () => void }) => {
            e.stopPropagation();
            this.setState({
                showStepsPopover: true,
                popoverPaneIndex: i
            });
        };
    }

    public closePopover() {
        this.setState({
            showStepsPopover: false
        });
    }

    public updateSteps(steps: TaskTemplateStep[], descriptionFileUrl?: string) {
        steps.forEach((step, i) => step.positionIndex = i + 1);
        this.setState({
            steps,
            descriptionFileUrl
        });
        this.props.onChange(steps);
    }

    public addInstruction() {
        let localSteps = this.state.steps;

        if (!localSteps) {
            localSteps = [];
        }

        localSteps.push({ ...new TaskTemplateStep(), id: -(++this.newStepId) });
        const paneIndex = localSteps.length - 1;

        this.setState({
            steps: localSteps,
            showStepsPopover: true,
            popoverPaneIndex: paneIndex
        });
        this.props.onChange(this.state.steps);
    }

    public descriptionFileUpdated(file: File) {
        this.setState({
            descriptionFileUrl: `${URL.createObjectURL(file)}#/${file.name}`
        });
        this.props.onChange(this.state.steps, file);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.taskTemplate && nextProps.taskTemplate.steps && nextProps.taskTemplate.steps !== prevState.steps) {
            partialState.steps = nextProps.taskTemplate.steps;
        }

        return partialState;
    }

    public render() {
        return (
            <ContentView>
                <TaskTemplateStepsPopover
                    steps={this.state.steps}
                    showStepsPopover={this.state.showStepsPopover}
                    closePopover={this.closePopover}
                    onUpdate={this.updateSteps}
                    addStep={this.addInstruction}
                    popoverPaneIndex={this.state.popoverPaneIndex}
                    descriptionFileUrl={this.state.descriptionFileUrl} />
                <HorizontalCardGrid title={i18n.t("common.instructions")} data={this.state.steps} onUpdate={this.updateSteps}>
                    {this.state.steps && this.state.steps.length > 0 ? (
                        this.state.steps.map((step, i) => (
                            <HorizontalCard key={step.id} editButtonId={`btnEditTaskTemplateStep${i}`} onClickEdit={this.openPopover(i)}>
                                <HorizontalCardImage id={`hciTaskTemplateStep${i}Media`} src={step.videoThumbnailUrl || step.pictureUrl} />
                                <h2 id={`h2TaskTemplateStep${i}Description`}><Dotdotdot clamp={2}>{step.description}</Dotdotdot></h2>
                            </HorizontalCard>
                        ))
                    ) : this.state.descriptionFileUrl ? (
                        <HorizontalCard key="descriptionfile-card" onClickEdit={this.openPopover(0)}>
                            <HorizontalCardAttachment fileUrl={this.state.descriptionFileUrl} />
                            <h2>{i18n.t("tasks.instructionPdf")}</h2>
                        </HorizontalCard>
                    ) : (
                                <HorizontalCardAddItem
                                    key="new-step-card"
                                    addItem={this.addInstruction}
                                    descriptionFileUpdated={this.descriptionFileUpdated}
                                />
                            )}
                    {this.state.steps && this.state.steps.length > 0 && !this.state.descriptionFileUrl &&
                        <HorizontalCardAddItem
                            key="new-step-card"
                            addItem={this.addInstruction}
                        />
                    }
                </HorizontalCardGrid>
            </ContentView>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateDetailView/TaskTemplateSteps/TaskTemplateSteps.tsx